export const START_REGISTRATION = 'START_REGISTRATION'
export const REGISTER = 'REGISTER'
export const REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE'
